module.exports = __webpack_public_path__ + "img/freehand_bg.cb298434.jpeg";